// Реестр статей документации без текстов: его импортирует src/seo/pages.ts,
// а значит и главный бандл лендинга. Тексты статей в ./content.ts, они грузятся
// только на страницах /docs.

export type DocsGroupId = 'start' | 'venue' | 'hall' | 'guests' | 'partners';

export interface DocsGroup {
  id: DocsGroupId;
  title: string;
}

export interface DocMeta {
  slug: string;
  group: DocsGroupId;
  title: string;
  /** Строка под названием на главной документации. */
  summary: string;
  seoTitle: string;
  seoDescription: string;
  /** Слова, которыми владелец ищет ту же тему: участвуют только в поиске. */
  keywords: string;
}

export const DOCS_PATH = '/docs';

export const DOCS_GROUPS: DocsGroup[] = [
  { id: 'start', title: 'Начало работы' },
  { id: 'venue', title: 'Управление заведением' },
  { id: 'hall', title: 'Работа в зале' },
  { id: 'guests', title: 'Гости' },
  { id: 'partners', title: 'Партнёрам' },
];

// Порядок массива задаёт порядок в навигации и ссылки «Назад» / «Дальше».
export const DOCS: DocMeta[] = [
  {
    slug: 'start',
    group: 'start',
    title: 'Быстрый старт',
    summary: 'От регистрации до первого чека: заведение, меню, касса и первый заказ.',
    seoTitle: 'Быстрый старт в Resstro: от регистрации до первого чека',
    seoDescription:
      'Как запустить заведение в Resstro самостоятельно: регистрация, профиль заведения, меню, подключение кассы кодом и первый заказ с оплатой.',
    keywords: 'начало работы запуск регистрация как начать первый заказ подключить настроить с нуля',
  },
  {
    slug: 'billing',
    group: 'start',
    title: 'Подписка и оплата',
    summary: 'Пробный период, тариф, продление и что будет, если не оплатить вовремя.',
    seoTitle: 'Подписка Resstro: тариф, пробный период и оплата',
    seoDescription:
      'Тариф Resstro и пробный период, как оплатить и продлить подписку, сменить период, отменить автопродление и что будет при неоплате.',
    keywords: 'тариф цена стоимость оплатить продлить автопродление счёт акт закрывающие документы возврат льготный период блокировка',
  },
  {
    slug: 'admin',
    group: 'venue',
    title: 'Админ-панель',
    summary: 'Меню, сотрудники, кассы, смены, склад и отчёты в браузере.',
    seoTitle: 'Админ-панель Resstro: меню, сотрудники, смены и склад',
    seoDescription:
      'Инструкция по веб-админке Resstro: вход, меню и импорт из iiko, сотрудники и роли, подключение касс, отчёты по сменам, склад и тех-карты, настройки.',
    keywords:
      'админка веб браузер меню блюда категории модификаторы стоп-лист закончилось сотрудники роли права пароль склад техкарты тех-карты инвентаризация поставка отчёт смена аналитика импорт сканер iiko r_keeper poster restik',
  },
  {
    slug: 'admin-app',
    group: 'venue',
    title: 'Resstro Admin',
    summary: 'Админка в iPhone и iPad: смена онлайн, заказы, меню и уведомления.',
    seoTitle: 'Resstro Admin для iPhone и iPad: админка в телефоне',
    seoDescription:
      'Приложение Resstro Admin: вход, навигация на iPhone и iPad, смена в реальном времени, меню, склад, устройства и уведомления.',
    keywords: 'приложение iphone ipad айфон айпад телефон мобильная админка ios уведомления пуши',
  },
  {
    slug: 'cashier',
    group: 'hall',
    title: 'Касса',
    summary: 'Смена, столы, заказы, оплата и работа без интернета на iPad, Android и Windows.',
    seoTitle: 'Касса Resstro: смена, заказы, оплата и офлайн-режим',
    seoDescription:
      'Инструкция по кассе Resstro для iPad, Android и Windows: подключение кодом, открытие и закрытие смены, столы, заказы, способы оплаты, закуп и работа без интернета.',
    keywords:
      'касса кассир смена открыть закрыть пересчёт стол зал заказ оплата наличные карта сдача скидка пречек чек вынос офлайн без интернета синхронизация списание поставка привязать подключить код отвязать',
  },
  {
    slug: 'waiter',
    group: 'hall',
    title: 'Официант',
    summary: 'Заказ у стола с телефона: подключение кодом, столы и отправка на кассу.',
    seoTitle: 'Приложение Resstro Официант: заказ у стола с телефона',
    seoDescription:
      'Как подключить приложение официанта Resstro: модуль «Официанты», установка APK, код подключения, столы, отправка заказа на кассу и оплата.',
    keywords: 'официант телефон заказ у стола модуль apk андроид код подключения отправить на кассу',
  },
  {
    slug: 'hardware',
    group: 'hall',
    title: 'Оборудование',
    summary: 'Принтеры чеков и кухни, банковские терминалы, экран гостя и меню на телевизоре.',
    seoTitle: 'Оборудование для кассы Resstro: принтеры, терминалы, экраны',
    seoDescription:
      'Какие принтеры подходят кассе Resstro и как их подключить, настройка банковского терминала, экран гостя и меню на телевизоре.',
    keywords:
      'принтер чековый кухонный печать xprinter epson star bixolon bluetooth usb com wi-fi lan терминал эквайринг сбер inpas arcus сбп слип экран гостя второй экран телевизор тв менюборд кодировка кракозябры',
  },
  {
    slug: 'qr-menu',
    group: 'guests',
    title: 'Электронное меню',
    summary: 'Меню в телефоне гостя: заказ к столу и навынос, онлайн-оплата через ЮKassa.',
    seoTitle: 'Электронное QR-меню Resstro: заказ и онлайн-оплата',
    seoDescription:
      'Как подключить электронное меню Resstro: свой домен, QR-код на столы, заказ гостя к столу и навынос, онлайн-оплата через ЮKassa.',
    keywords: 'qr куар электронное меню гость заказ домен cname dns юkassa юкасса онлайн оплата shopid секретный ключ дозаказ',
  },
  {
    slug: 'people',
    group: 'guests',
    title: 'Resstro People',
    summary: 'Приложение для гостей: заведения рядом, меню, заказ и бронь стола.',
    seoTitle: 'Resstro People: приложение для гостей заведений',
    seoDescription:
      'Что умеет гостевое приложение Resstro People: заведения рядом, меню, заказ к столу и с собой, бронь стола. Как заведению настроить карточку.',
    keywords: 'гостевое приложение гость бронь бронирование стола заведения рядом отзывы',
  },
  {
    slug: 'supplier',
    group: 'partners',
    title: 'Кабинет поставщика',
    summary: 'Каталог для ресторанов, заявки, отгрузки, условия оплаты и долги заведений.',
    seoTitle: 'Кабинет поставщика Resstro: каталог, заявки и долги',
    seoDescription:
      'Инструкция для поставщиков Resstro: регистрация, запуск каталога, заявки от ресторанов, отгрузка, отсрочка платежа, долги и подписка.',
    keywords: 'поставщик закуп магазин каталог товары заявки отгрузка отсрочка долги 1с интеграция b2b',
  },
  {
    slug: 'wholesaler',
    group: 'partners',
    title: 'Resstro Оптовик',
    summary: 'Производство и опт: тех-карты, приходы, склад, продажи с накладной и курьеры.',
    seoTitle: 'Resstro Оптовик: инструкция по производству и опту',
    seoDescription:
      'Как вести производство и оптовые продажи в Resstro Оптовик: товары и тех-карты, приходы, продажи с накладной, возвраты, склад, финансы и курьеры.',
    keywords: 'оптовик опт производство пекарня фабрика-кухня техкарта тех-карта партия приход накладная продажа возврат обмен курьеры',
  },
  {
    slug: 'courier',
    group: 'partners',
    title: 'Приложение курьера',
    summary: 'Для курьеров оптовика: смена, маршрут, точки, оплата, обмен и долги.',
    seoTitle: 'Приложение курьера Resstro: маршрут, точки и оплата',
    seoDescription:
      'Инструкция для курьера оптовика Resstro: вход по коду, начало смены, маршрут, работа на точке, оплата и долги, обмен и завершение маршрута.',
    keywords: 'курьер экспедитор маршрут точка доставка развоз долг обмен накладная геолокация',
  },
];

export function docPath(slug: string): string {
  return `${DOCS_PATH}/${slug}`;
}

export function findDoc(slug: string | undefined): DocMeta | undefined {
  return slug ? DOCS.find((d) => d.slug === slug) : undefined;
}

export function findGroup(id: DocsGroupId): DocsGroup {
  return DOCS_GROUPS.find((g) => g.id === id) ?? DOCS_GROUPS[0];
}

export function docsInGroup(id: DocsGroupId): DocMeta[] {
  return DOCS.filter((d) => d.group === id);
}

export function docNeighbours(slug: string): { prev: DocMeta | null; next: DocMeta | null } {
  const i = DOCS.findIndex((d) => d.slug === slug);
  return {
    prev: i > 0 ? DOCS[i - 1] : null,
    next: i >= 0 && i < DOCS.length - 1 ? DOCS[i + 1] : null,
  };
}
